import { defineAsyncComponent } from 'vue';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';

export default {
    computed: {
        ...mapState(usePageStore, {
            page: store => store.page
        }),
        searchCom({ page }) {
            return page.searchCenter ? 'SearchMoreCenter' : 'SearchMore';
        },
        mobileOutCom({ page }) {
            return page.searchCenter ? 'MobileOutCenter' : 'MobileOut';
        },
        searchTag({ page }) {
            return page.searchCenter ? 'SearchTagCenter' : 'SearchTag';
        }
    },
    components: {
        SearchMore: defineAsyncComponent(() => import(/* webpackChunkName: "modules/md-search-bar/template4/search-more" */ './search-more.vue')),
        SearchMoreCenter: defineAsyncComponent(() =>
            import(/* webpackChunkName: "modules/md-search-bar/template4/search-more-center" */ './search-more-center.vue')),
        MobileOut: defineAsyncComponent(() => import(/* webpackChunkName: "modules/md-search-bar/template4/mobile-out" */ './mobile-out.vue')),
        MobileOutCenter: defineAsyncComponent(() =>
            import(/* webpackChunkName: "modules/md-search-bar/template4/mobile-out-center" */ './mobile-out-center.vue')),
        SearchTag: defineAsyncComponent(() => import(/* webpackChunkName: "modules/md-search-bar/template4/search-tag" */ './search-tag.vue')),
        SearchTagCenter: defineAsyncComponent(() =>
            import(/* webpackChunkName: "modules/md-search-bar/template4/search-tag-center" */ './search-tag-center.vue'))
    }
};
